import { useContext } from "react";
import { CartContext } from "../../providers/CartContext";
import { Header } from "./Header";
import { Main } from "./Main";
import { DashboardContent } from "./style";
import { Modal } from "../../components/Modal";

export const Dashboard = () => {
  const { modal } = useContext(CartContext);
  return (
    <DashboardContent>
      {modal && <Modal />}
      <Header />
      <Main />
    </DashboardContent>
  );
};
